<template>
  <div class="admin" v-if="currentUser !== null">
    <p>Prijavljen kot: <strong>{{ userEmail }}</strong> | <span @click="userSignout">Odjava iz računa</span></p>
    <h2 v-if="categoryContentFull == null">Trenutno še ni podatkov.</h2>
    <h2>Vseh vnosov: {{ allEntries }}</h2>
    <div
      class="table-wrapper"
      v-for="(paralelka, propertyNameTest, index) in categoryContentFull"
      :key="index"
    >
      <h1>{{ propertyNameTest | initialLetterUpper }}</h1>
      <table v-for="(ucenec, propertyName, index) in paralelka" :key="`cetrtosolci-${index}`">
        <h2>{{ propertyName | modifyRazredString }}</h2>
        <tr>
          <th>Ime in priimek starša</th>
          <th>Ime in priimek učenca</th>
          <th>Razred</th>
          <th>Prešolanje</th>
          <th v-if="propertyNameTest === 'prvošolci'">Jutranje varstvo</th>
          <th v-if="propertyNameTest === 'prvošolci'">Čas jutranjega varstva</th>
          <th>Podaljšano bivanje</th>
          <th>Čas podaljšanega bivanja</th>
        </tr>
        <tr v-for="(ucenecItem, ucenecIndex) in ucenec" :key="ucenecIndex" class="ucenecEntry">
          <td>{{ ucenecItem.imeInPriimekStarsa }}</td>
          <td>{{ ucenecItem.imeInPriimekUcenca }}</td>
          <td>{{ ucenecItem.razred | modifyRazredString }}</td>
          <td v-html="$options.filters.iconify(ucenecItem.presolanje)"></td>
          <td
            v-if="propertyNameTest === 'prvošolci'"
            v-html="$options.filters.iconify(ucenecItem.jutranjeVarstvo)"
          ></td>
          <td v-if="propertyNameTest === 'prvošolci'">{{ ucenecItem.jutranjePrihod }}</td>
          <td v-html="$options.filters.iconify(ucenecItem.podaljsanoBivanje)"></td>
          <td v-html="$options.filters.iconify(ucenecItem.casPodaljsanoBivanje)"></td>
        </tr>
      </table>
    </div>
    <Loader :isActive="loaderActive"></Loader>
  </div>
</template>

<script>
import firebase from "firebase";
import Loader from "@/components/Loader.vue";

export default {
  name: "Admin",
  components: {
    Loader
  },
  data: function() {
    return {
      categoryContentFull: null,
      loaderActive: true,
      entriesNum: [],
      allEntries: null,
      currentUser: null,
      userEmail: null
    };
  },
  mounted: function() {
    var that = this;

    that.currentUser = firebase.auth().currentUser;
    if (that.currentUser !== null) {
      that.userEmail = firebase.auth().currentUser.email;
      firebase
        .database()
        .ref("anketa/")
        .once("value")
        .then(function(snapshot) {
          that.categoryContentFull = snapshot.val();
          that.loaderActive = false;

          setTimeout(function() {
            that.countEntries();
          }, 100);

          setTimeout(function() {
            that.countAllEntries();
          }, 1000);
        });
    } else {
      console.log("You don't have the rights to see this page!");
    }
  },

  filters: {
    iconify: function(value) {
      if (value === "ne" || value === "/") {
        return (value = "<i class='fas fa-times red'></i>");
      } else if (value === "da") {
        return (value = "<i class='fas fa-check green'></i>");
      } else {
        return value;
      }
    },

    modifyRazredString: function(value) {
      if (value === "razredA") {
        return (value = "Razred A");
      } else {
        return (value = "Razred B");
      }
    },

    initialLetterUpper: function(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },

  methods: {
    countEntries: function() {
      var table = document.getElementsByTagName("table"),
        that = this;

      table.forEach(function(tableItem) {
        var tr = tableItem.getElementsByClassName("ucenecEntry"),
          trLength = " (" + tr.length + ")",
          tableItemHeading = tableItem.querySelector("h2").textContent;

        that.entriesNum.push(tr.length);
        tableItem.querySelector("h2").textContent = tableItemHeading + trLength;
      });
    },

    userSignout: function() {
      console.log("User should get signed out");
      firebase
        .auth()
        .signOut()
        .then(function() {
          // Sign-out successful.
          window.location.reload();
          console.log("signout succesfull");
        })
        .catch(function(error) {
          // An error happened.
          console.log("There was an error while signing out: " + error.message);
        });
    },

    countAllEntries: function() {
      var sumTotal = 0;

      for (var i = 0; i < this.entriesNum.length; i++) {
        sumTotal = sumTotal + this.entriesNum[i];
        this.allEntries = sumTotal;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.admin {
  width: 80%;
  margin: 0 auto;
  background-color: white;
  padding: 30px 40px;
  box-shadow: 0px 10px 50px rgb(184, 165, 124);
  margin-bottom: 100px;

  > p {
    text-align: left;
    font-size: 14px;

    strong {
      margin-right: 10px;
    }

    span {
      margin-left: 10px;
      &:hover {
        cursor: pointer;
      }
    }
  }

  table {
    margin-top: 40px;
    text-align: left;

    &:first-of-type {
      margin-top: 0;
    }

    th {
      padding: 10px;
    }

    tr,
    td {
      width: 200px;
      padding: 15px 10px;
    }

    .fa-check {
      color: green;
    }

    .fa-times {
      color: red !important;
    }

    tr:nth-of-type(2n - 1) {
      background-color: #eee;
    }
  }

  .fa-check.green {
    color: green !important;
  }
}
</style>